module.exports = __webpack_public_path__ + "static/media/birds_fly_from-window1 - Copy.6e7e2ba7.gif";